module.exports = __webpack_public_path__ + "b8e906a1-f5e8-4bf1-8e80-82c646ca4d5f.woff";